module.exports = __webpack_public_path__ + "img/code-fork.7bccead6.svg";